import React, { useRef } from 'react';
import { StyleSheet } from 'react-native';
import { A } from '@expo/html-elements';
import { theme, TYPE_CONFIG, usePressableState } from '@sweetgreen/garnish';

import { getLinkWebAttributes } from '@order/utils';

import type { useOrganizationLinksFooterContentfulData } from '../hooks';

export const OrganizationLinksFooterLink = (props: LinkProps) => {
  const { link } = props;

  const linkRef = useRef(null);
  const linkPressableState = usePressableState(linkRef);

  const linkStyles = [
    styles.link,
    linkPressableState.isHovered ? styles.linkHover : undefined,
  ];

  return (
    <A
      ref={linkRef}
      href={link.url}
      style={linkStyles}
      accessibilityRole="link"
      {...getLinkWebAttributes()}
    >
      {link.label}
    </A>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type LinkProps = Readonly<{
  link: ReturnType<
    typeof useOrganizationLinksFooterContentfulData
  >['contentfulFooter']['sections'][0]['links'][0];
}>;

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  link: {
    color: theme.colors.DARK_KALE,
    ...TYPE_CONFIG.BODY['16'],
    fontWeight: 'normal',
  },
  linkHover: {
    textDecorationLine: 'underline',
  },
});
